module.exports = __webpack_public_path__ + "category_loading_car.svg";